import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';

export default function LatestNewsList() {
  const items = [...newsList].sort((a, b) => (a.publishDate < b.publishDate ? 1 : -1)).slice(0, 5);

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-5">
        <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">最新新闻</h3>
        <Link to="/news" className="cursor-pointer whitespace-nowrap text-sm text-primary-700 hover:text-accent-600 flex items-center gap-1">
          查看更多
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <ul className="divide-y divide-background-200">
        {items.map((item) => (
          <li key={item.id} className="py-3 md:py-4 first:pt-0 last:pb-0">
            <Link to={`/detail/${item.id}`} className="cursor-pointer flex gap-3 md:gap-4 group">
              <div className="w-20 h-16 md:w-28 md:h-20 shrink-0 rounded-md overflow-hidden">
                <img src={item.cover} alt={item.title} className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-700 line-clamp-2 leading-snug">
                  {item.title}
                </p>
                <div className="flex items-center gap-2 mt-2 flex-wrap">
                  <span className="text-xs bg-secondary-100 text-secondary-900 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.category}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.publishDate}</span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}